import { useAtom } from 'jotai';
import { useEffect, useState } from 'react';

import { firstVisitAtom } from '../../../RootDashboard';
import { DealWithFarthestState } from '../../../utils';

const useStepperAnimation = (
  deal: DealWithFarthestState,
  activeStep: number,
  payoffLoading: boolean,
): { animate: boolean; show: boolean } => {
  const [firstVisit, setFirstVisit] = useAtom(firstVisitAtom);

  const isFirstVisit = deal?.isCobuyer
    ? !deal?.cobuyer?.dashboard_visited
    : !deal?.customer?.dashboard_visited;

  const [animate, setAnimate] = useState(false);
  const [show, setShow] = useState(!isFirstVisit);

  useEffect(() => {
    if (show || firstVisit === 'pending' || payoffLoading) return;
    if (activeStep > 0) setAnimate(true);
    setShow(true);
    setFirstVisit('none');
  }, [show, payoffLoading, firstVisit, activeStep, setFirstVisit]);

  return { animate, show };
};

export default useStepperAnimation;
